import { Menu, MenuButton, MenuItem, MenuItems } from '@headlessui/react';
import { ChevronDownIcon } from '@heroicons/react/20/solid';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import axios from 'axios';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { MdArrowLeft, MdEmail, MdLock, MdVisibility, MdVisibilityOff } from 'react-icons/md';
import { useMediaQuery } from 'react-responsive';
import { useNavigate } from 'react-router-dom';
import { web_url } from '../constant';


function LoginPage2() {
    const channel = new BroadcastChannel("auth_channel");

    const isXlOrLarger = useMediaQuery({ minWidth: 1280 });
    const [language, setLanguage] = useState(() => {
        const languageNow = localStorage.getItem('language') ? localStorage.getItem('language') : 'English';
        return languageNow;
    })
    const { t, i18n } = useTranslation();
    useEffect(() => {
        switch (language) {
            case 'English':
                i18n.changeLanguage('en');
                break;
            case 'Sinhala':
                i18n.changeLanguage('si');
                break;
            case 'Tamil':
                i18n.changeLanguage('ta');
                break;
            default:
                i18n.changeLanguage('en');
                break;
        }
        localStorage.setItem('language', language);
    }, [language]);

    useEffect(() => {
        if (!localStorage.getItem('category')) {
            navigate('/loginas');
        }
    }, [])

    const navigate = useNavigate();
    const [open, setOpen] = useState(false);

    const handleClose = () => {
        setOpen(false);
    };

    const changeLanguage = (lang) => {
        i18n.changeLanguage(lang);
    };

    const [loginDetails, setLoginDetails] = useState(
        {
            email: '',
            password: ''
        }
    )

    const [errors, setErrors] = useState(
        {
            noEmail: false,
            invalidEmail: false,
            noPassword: false,
            invalidPassword: false
        }
    )

    const [isRemember, setIsRemember] = useState(false);

    useEffect(() => {
        const handleBeforeUnload = (event) => {
            localStorage.removeItem('category')
        };
        window.addEventListener('beforeunload', handleBeforeUnload);

        return () => {
            window.removeEventListener('beforeunload', handleBeforeUnload);
        };
    }, []);

    const [openError, setOpenError] = useState(false);
    const [error, setError] = useState('');

    const handleClickOpenError = (err) => {
        if (err.toLowerCase().includes('internal server error')) {
            setError(t('t93'));
        } else if (err.toLowerCase().includes('not active')) {
            setError(t('t102'));
        } else if (err.toLowerCase().includes('invalid credentials')) {
            setError(t('t100'));
        } else if (err.toLowerCase().includes('verify your email to login')) {
            setError(t('t347'));
        } else {
            setError(t('t94'));
        }
        setOpenError(true);
    };

    const handleCloseError = () => {
        setOpenError(false);
        localStorage.removeItem('/')
        navigate('/loginas')
    };

    const [isLoading, setIsLoading] = useState(false);

    const handleContinue = () => {

        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        const nameRegex = /^(?!.*script)[a-z0-9.]{7,}$/i;
        let newErrors = {};
        newErrors.noEmail = !loginDetails.email;
        newErrors.noPassword = !loginDetails.password;

        if (loginDetails.password && (loginDetails.password).length < 8) {
            newErrors.invalidPassword = true;
        } else {
            newErrors.invalidPassword = false;
        }

        if ((localStorage.getItem('category')).toUpperCase() === "STUDENT" || (localStorage.getItem('category')).toUpperCase() === "TEACHER") {
            if ((loginDetails.email) && !emailRegex.test(loginDetails.email) && !nameRegex.test(loginDetails.email)) {
                newErrors.invalidEmail = true;
            } else {
                newErrors.invalidEmail = false;
            }
        } else {
            if ((loginDetails.email) && !emailRegex.test(loginDetails.email)) {
                newErrors.invalidEmail = true;
            } else {
                newErrors.invalidEmail = false;
            }
        }

        setErrors(newErrors);

        if (Object.values(newErrors).some((error) => error)) {
            return;
        }

        const role = localStorage.getItem('category') ? (localStorage.getItem('category')) : "Student";
        const user = {
            userEmail: loginDetails.email.toLowerCase(),
            userPassword: loginDetails.password,
            userRole: role.toUpperCase()
        };

        setIsLoading(true);

        const config = {
            headers: {
                'Content-Type': 'application/json',
            },
        };

        axios.post(`${web_url}/api/auth/login`, user, config)
            .then((response) => {
                console.log('login', response.data);

                if (isRemember) {
                    const currentTime1 = new Date();
                    const futureTime1 = new Date(currentTime1.getTime() + 24 * 60 * 60 * 1000);
                    localStorage.setItem("logDetails", JSON.stringify({ token: response.data.token, category: response.data.userRole, email: user.userEmail, exp: futureTime1 }))
                } else {
                    const currentTime = new Date();
                    const futureTime = new Date(currentTime.getTime() + 3 * 60 * 60 * 1000);
                    localStorage.setItem("logDetails", JSON.stringify({ token: response.data.token, category: response.data.userRole, email: user.userEmail, exp: futureTime }))
                }
                channel.postMessage("bridge_login_found");
                sessionStorage.setItem("greetings", "true");

                if ((localStorage.getItem('category')).toUpperCase() === "TEACHER") {
                    localStorage.removeItem('category');
                    if (isXlOrLarger) {
                        navigate('/desktop/teacher/dashboard');
                    } else {
                        navigate('/mobile/teacher/greeting');
                    }
                } else if ((localStorage.getItem('category')).toUpperCase() === "STUDENT") {
                    localStorage.removeItem('category');
                    if (isXlOrLarger) {
                        navigate('/desktop/student/dashboard');
                    } else {
                        navigate('/mobile/student/dashboard');
                    }
                } else if ((localStorage.getItem('category')).toUpperCase() === "RESEARCHER") {
                    localStorage.removeItem('category');
                    if (isXlOrLarger) {
                        navigate('/mobile/researcher/dashboard');
                    } else {
                        navigate('/mobile/researcher/dashboard');
                    }
                } else if ((localStorage.getItem('category')).toUpperCase() === "TRANSLATOR") {
                    localStorage.removeItem('category');
                    if (isXlOrLarger) {
                        navigate('/desktop/translator/dashboard');
                    } else {
                        navigate('/mobile/translator/greeting');
                    }
                }
                setIsLoading(false);
            })
            .catch((err) => {
                console.log('login', err);

                if (err.response) {

                    if (err.response.data.error) {
                        handleClickOpenError(err.response.data.error);
                    } else if (err.response.data.message) {
                        handleClickOpenError(err.response.data.message);
                    } else if (err.response.data.token) {
                        handleClickOpenError(err.response.data.token);
                    } else {
                        handleClickOpenError("An unknown error occured");
                    }

                }
                setIsLoading(false);
            })


    }

    const [isVisible, setIsVisible] = useState(false);
    const [isVisibleText, setIsVisibleText] = useState(true);

    const handleVisiblityClick = () => {
        setIsVisible(!isVisible);
        if (!isVisible && loginDetails.password.length > 0) {
            setIsVisibleText(true);
        } else if (isVisible && loginDetails.password.length > 0) {
            setIsVisibleText(false);
        }
    }

    const categoryUser = () => {
        const userC = localStorage.getItem('category') ? localStorage.getItem('category') : "Error";
        if (userC === "Teacher") {
            return t('t353')
        } else if (userC === "Student") {
            return t('t354')
        } else if (userC === "Researcher") {
            return t('t355')
        } else if (userC === "Translator") {
            return t('t356')
        } else {
            return t('t95')
        }
    }

    const categoryUserForSmallHeadding = () => {
        const userC = localStorage.getItem('category') ? localStorage.getItem('category') : "Error";
        if (userC === "Student") {
            return t('t468')
        } else {
            return t('t467')
        }
    }

    return (
        <div className={`${i18n.language === "en" ? "font-urban" : (i18n.language === "si" ? "font-noto" : "font-mukta")} bg-bgImg md:bg-bglarge bg-no-repeat bg-cover min-h-screen w-screen flex flex-col  md:items-center`}>
            <div className="fixed inset-0 bg-white/50 z-0"></div>
            <Menu as="div" className="absolute top-0 right-0 m-[10px] text-left items-right z-20">
                <div>
                    <MenuButton className="inline-flex w-full justify-center gap-x-1.5 rounded-md bg-white px-3 py-2 text-sm font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-black hover:bg-gray-50">
                        {language === "Sinhala" ? "සිංහල" : (language === "Tamil" ? "தமிழ்" : language)}
                        <ChevronDownIcon aria-hidden="true" className="-mr-1 size-5 text-gray-400" />
                    </MenuButton>
                </div>

                <MenuItems
                    transition
                    className="absolute right-0 z-10 mt-2 w-56 origin-top-right rounded-md bg-white shadow-lg ring-1 ring-black/5 transition focus:outline-none data-[closed]:scale-95 data-[closed]:transform data-[closed]:opacity-0 data-[enter]:duration-100 data-[leave]:duration-75 data-[enter]:ease-out data-[leave]:ease-in"
                >
                    <div className="py-1">
                        <MenuItem>
                            <button
                                className="text-left w-full block px-4 py-2 text-sm text-gray-700 focus:bg-gray-100 focus:text-gray-900 focus:outline-none"
                                onClick={() => {
                                    setLanguage("English");
                                    changeLanguage('en')
                                }}
                            >
                                English
                            </button>
                        </MenuItem>
                        <MenuItem>
                            <button
                                className="text-left w-full block px-4 py-2 text-sm text-gray-700 focus:bg-gray-100 focus:text-gray-900 focus:outline-none"
                                onClick={() => {
                                    setLanguage("Sinhala");
                                    changeLanguage('si')
                                }}
                            >
                                සිංහල
                            </button>
                        </MenuItem>
                        <MenuItem>
                            <button
                                className="text-left w-full block px-4 py-2 text-sm text-gray-700 focus:bg-gray-100 focus:text-gray-900 focus:outline-none"
                                onClick={() => {
                                    setLanguage("Tamil");
                                    changeLanguage('ta')
                                }}
                            >
                                தமிழ்
                            </button>
                        </MenuItem>
                    </div>
                </MenuItems>
            </Menu>
            <div className='relative z-10 h-full  w-full'>
                <div className='flex items-center justify-start cursor-pointer mt-[20px] xl:mt-[100px] 2xl:mt-[150px] xl:ml-[170px] 2xl:ml-[250px]'>
                    <MdArrowLeft className='text-[25px] md:text-[35px] lg:text-[33px] xl:text-[25px] 2xl:text-[22px]' />
                    <button className={`z-10 hover:underline font-bold ${i18n.language === "en" ? "text-[17px] md:text-[23px] lg:text-[23px] xl:text-[15px] 2xl:text-[22px]" : (i18n.language === "si" ? "text-[14px] md:text-[19px] lg:text-[21px] xl:text-[13px] 2xl:text-[18px]" : "text-[14px] md:text-[19px] lg:text-[20px] xl:text-[13px] 2xl:text-[18px]")}`} onClick={() => {
                        navigate('/loginas');
                    }}>
                        {t('t455')}
                    </button>
                </div>
                <div className='pl-[30px] pr-[30px] flex flex-col justify-start items-center h-full w-full absolute top-[17vh] md:top-[13vh] xl:top-[14vh] 2xl:top-[17vh]  '>
                    <div className='md:w-[400px] lg:w-[500px] xl:w-[550px]  2xl:w-[500px] flex flex-col items-center justify-center'>
                        <img src="/images/logo.svg" className="h-[100px] md:h-[130px] xl:h-[120px] 2xl:h-[130px]" alt='logo' />
                        <p className={`text-[#1E2533] text-center font-[600] leading-[27px] xl:leading-[30px] ${i18n.language === "en" ? "text-[21px] md:text-[23px] lg:text-[27px] xl:text-[27px] 2xl:text-[28px]" : (i18n.language === "si" ? "text-[19px] md:text-[22px] lg:text-[19px] xl:text-[22px] 2xl:text-[18px]" : "text-[16px] md:text-[19px] lg:text-[17px] xl:text-[20px] 2xl:text-[18px]")} mt-[20px]`}>{categoryUser()}</p>
                        <p className={`text-[#1E2533] text-center leading-[15px] md:leading-[20px] ${i18n.language === "en" ? "text-[13px] md:text-[13px] lg:text-[17px] xl:text-[15px] 2xl:text-[17px]" : (i18n.language === "si" ? "text-[11px] md:text-[13px] lg:text-[12px] xl:text-[12px] 2xl:text-[14px]" : "text-[10px] md:text-[13px] lg:text-[12px] xl:text-[11px] 2xl:text-[11px]")} mt-[5px]`}>{categoryUserForSmallHeadding()}</p>
                        <div className="w-full items-center mt-[20px] flex rounded-md bg-[#F1F6FB] px-[10px] h-[60px] md:h-[70px] xl:h-[60px] 2xl:h-[70px] outline outline-1 -outline-offset-1 outline-gray-300 focus-within:outline focus-within:outline-2 focus-within:-outline-offset-2 focus-within:outline-gray-400">
                            <MdEmail size="24px" color="#8189B0" />
                            <input type="text" name="email" className={`ml-[10px] w-full bg-[#F1F6FB] text-[13px] md:text-[15px] text-gray-900 placeholder:text-[#8189B0] focus:outline focus:outline-0 ${i18n.language === "en" ? "placeholder:text-[15px] md:placeholder:text-[19px] lg:placeholder:text-[20px] xl:placeholder:text-[15px] 2xl:placeholder:text-[17px]" : (i18n.language === "si" ? "placeholder:text-[12x] md:placeholder:text-[16px] lg:placeholder:text-[16px] xl:placeholder:text-[13px] 2xl:placeholder:text-[15px]" : "placeholder:text-[12px] md:placeholder:text-[15px] lg:placeholder:text-[16px] xl:placeholder:text-[12px] 2xl:placeholder:text-[15px]")}`} placeholder={(localStorage.getItem('category')) ? ((localStorage.getItem('category')).toUpperCase() === "STUDENT" || (localStorage.getItem('category')).toUpperCase() === "TEACHER" ? t('t441') : t('t14')) : t('t14')}
                                onChange={(e) => {
                                    setLoginDetails((prevState) => ({
                                        ...prevState, email: (e.target.value).trim().toLowerCase()
                                    }))
                                }}
                            />
                        </div>
                        <div className='w-full flex flex-col items-start justify-start'>
                            {errors.noEmail && (localStorage.getItem('category')) && (localStorage.getItem('category')).toUpperCase() === "STUDENT" &&
                                <p className='text-[#ff0000] text-[12px] mt-[5px]'>{t('t442')}</p>
                            }
                            {errors.noEmail && (localStorage.getItem('category')) && (localStorage.getItem('category')).toUpperCase() !== "STUDENT" &&
                                <p className='text-[#ff0000] text-[12px] mt-[5px]'>{t('t15')}</p>
                            }

                            {errors.invalidEmail && (localStorage.getItem('category')) && (localStorage.getItem('category')).toUpperCase() === "STUDENT" &&
                                <>
                                    <p className={`text-[#ff0000] ${i18n.language === "en" ? "text-[12px]" : "text-[10px]"} mt-[5px]`}>{t('t443')}</p>
                                    <p className={`text-[#ff0000] ${i18n.language === "en" ? "text-[12px]" : "text-[10px]"} mt-[5px]`}>{t('t444')}</p>
                                    <p className={`text-[#ff0000] ${i18n.language === "en" ? "text-[12px]" : "text-[10px]"} mt-[5px]`}>{t('t445')}</p>
                                </>

                            }
                            {
                                errors.invalidEmail && (localStorage.getItem('category')) && (localStorage.getItem('category')).toUpperCase() !== "STUDENT" &&
                                <p className='text-[#ff0000] text-[12px] mt-[5px]'>{t('t16')}</p>
                            }
                        </div>



                        <div className="w-full items-center mt-[20px] flex rounded-md bg-[#F1F6FB] pl-[10px] pr-[20px] h-[60px] md:h-[70px] xl:h-[60px] 2xl:h-[70px] outline outline-1 -outline-offset-1 outline-gray-300 focus-within:outline focus-within:outline-2 focus-within:-outline-offset-2 focus-within:outline-gray-400">
                            <MdLock size="26px" color="#8189B0" />
                            <input type={isVisibleText ? "text" : "password"} name="password" className={`ml-[10px] mr-[10px] w-full bg-[#F1F6FB] text-gray-900 text-[15px] ${isVisibleText ? 'text-[15px] tracking-wide' : 'text-[25px] tracking-widest'} placeholder:text-[#8189B0] focus:outline focus:outline-0 ${i18n.language === "en" ? "placeholder:text-[15px] md:placeholder:text-[19px] lg:placeholder:text-[20px] xl:placeholder:text-[15px] 2xl:placeholder:text-[17px]" : (i18n.language === "si" ? "placeholder:text-[12x] md:placeholder:text-[16px] lg:placeholder:text-[16px] xl:placeholder:text-[13px] 2xl:placeholder:text-[15px]" : "placeholder:text-[12px] md:placeholder:text-[15px] lg:placeholder:text-[16px] xl:placeholder:text-[12px] 2xl:placeholder:text-[15px]")}`} style={{}} placeholder={t('t17')}
                                onChange={(e) => {
                                    setLoginDetails((prevState) => ({
                                        ...prevState, password: e.target.value
                                    }));
                                    if (!isVisible && e.target.value.length > 0) {
                                        setIsVisibleText(false);
                                    } else {
                                        setIsVisibleText(true);
                                    }
                                }}
                            />
                            {
                                isVisible ? <MdVisibilityOff onClick={handleVisiblityClick} size="24px" color="#8189B0" /> : <MdVisibility onClick={handleVisiblityClick} size="24px" color="#8189B0" />
                            }
                        </div>
                        <div className='w-full flex flex-col items-start justify-start'>
                            {errors.noPassword &&
                                <p className='text-[#ff0000] text-[12px] mt-[5px]'>{t('t18')}</p>
                            }
                            {errors.invalidPassword &&
                                <p className='text-[#ff0000] text-[12px] mt-[5px]'>{t('t19')}</p>
                            }
                        </div>

                        <div className='flex items-start justify-start w-full'>
                            <p className={`mt-[10px] mb-[10px] text-[#333333] ${i18n.language === "en" ? "text-[14px] md:text-[18px] xl:text-[15px] 2xl:text-[16px]" : (i18n.language === "si" ? "text-[11px] md:text-[14px] xl:text-[14px] 2xl:text-[14px]" : "text-[10px] md:text-[14px] xl:text-[12px] 2xl:text-[14px]")} text-center`}>{t('t20_1')}  <span onClick={() => (navigate('/forgotpasswordpage'))} className={`font-[700] text-[#333333] hover:cursor-pointer underline`}>{t('t20_2')}</span></p>
                        </div>

                        <button onClick={handleContinue} disabled={isLoading} className="text-[18px] mt-[15px] rounded-lg pt-[10px] pb-[10px] w-full hover:bg-opacity-80 bg-[#EFAE03] text-white font-bold hover:cursor-pointer flex items-center justify-center">
                            {isLoading ? (
                                <div className="items-center justify-center flex">
                                    <div className='w-5 h-5 border-2 border-t-transparent border-white rounded-full animate-spin'></div>
                                </div>
                            ) : (
                                t('t21')
                            )}
                        </button>
                        <p className={`text-[#333333] ${i18n.language === "en" ? "text-[14px] md:text-[18px] xl:text-[15px] 2xl:text-[16px]" : (i18n.language === "si" ? "text-[12px] md:text-[14px] xl:text-[14px] 2xl:text-[14px]" : "text-[11px] md:text-[14px] xl:text-[12px] 2xl:text-[14px]")} text-center mt-[20px] mb-[20px]`}>{t('t8')} <span onClick={() => (navigate('/createnewaccount'))} className={`font-[700] text-[#333333] hover:cursor-pointer underline`}>{t('t9')}</span></p>
                        <div className='flex items-center justify-center mt-[10px] pb-[50px] w-full '>
                            <input type='checkbox' name='remember'
                                onChange={(e) => (setIsRemember(e.target.checked))} />
                            <label className={`${i18n.language === "en" ? "text-[14px] md:text-[18px] xl:text-[15px] 2xl:text-[16px]" : (i18n.language === "si" ? "text-[12px] md:text-[14px] xl:text-[14px] 2xl:text-[14px]" : "text-[11px] md:text-[14px] xl:text-[12px] 2xl:text-[14px]")} text-black ml-[10px]`}>{t('t22')}</label>
                        </div>

                        <Dialog
                            open={open}
                            onClose={handleClose}
                            aria-labelledby="custom-dialog-title"
                            aria-describedby="custom-dialog-description"
                            className="backdrop-blur-sm"
                        >
                            <DialogTitle
                                id="custom-dialog-title"
                                className="text-2xl font-bold text-gray-800 border-b border-gray-300 pb-2"
                            >
                                ⚠️  {t('t48')}
                            </DialogTitle>
                            <DialogContent className="bg-gray-50">
                                <DialogContentText
                                    id="custom-dialog-description"
                                    className="text-gray-600 text-md mt-2"
                                >
                                    {t('t10')}
                                </DialogContentText>
                            </DialogContent>
                            <DialogActions className="px-4 py-2">
                                <Button
                                    onClick={handleClose}
                                    className="bg-[#F2AC0E] text-white px-4 py-2 rounded-md"
                                    style={{ backgroundColor: '#F2AC0E', color: 'white', fontWeight: 'bold' }}
                                >
                                    {t('t13')}
                                </Button>
                            </DialogActions>
                        </Dialog>

                        <Dialog
                            open={openError}
                            onClose={handleCloseError}
                            aria-labelledby="custom-dialog-title"
                            aria-describedby="custom-dialog-description"
                            className="backdrop-blur-sm"
                        >
                            <DialogTitle
                                id="custom-dialog-title"
                                className="text-2xl font-bold text-gray-800 border-b border-gray-300 pb-2"
                            >
                                {t('t95')}
                            </DialogTitle>
                            <DialogContent className="bg-gray-50">
                                <DialogContentText
                                    id="custom-dialog-description"
                                    className="text-gray-600 text-md mt-2"
                                >
                                    {error}
                                </DialogContentText>
                            </DialogContent>
                            <DialogActions className="px-4 py-2">
                                <Button
                                    onClick={handleCloseError}
                                    className="bg-[#F2AC0E] text-white px-4 py-2 rounded-md"
                                    style={{ backgroundColor: '#F2AC0E', color: 'white', fontWeight: 'bold' }}
                                >
                                    {t('t96')}
                                </Button>
                            </DialogActions>
                        </Dialog>
                    </div>
                </div>

            </div>
        </div>
    );
}

export default LoginPage2;